// HTMLの生成はRails側で行うため、全体はComponentを作らない
import {
  onMounted,
  nextTick,
  ref
} from 'vue'

import FeaturedBadges from '@components/FeatureBadges.vue'
import InquiryForm from './InquiryForm.vue'
import RecentlyViewedProperties from './RecentlyViewedProperties.vue'
import ShareBookmark from './ShareBookmark.vue'

import { useAjax } from '@composables/useAjax.js'
import { useIntlTel } from '@composables/useIntlTel.js'
import { usePropertySearchBox } from '@composables/usePropertySearchBox.js'
import { useCsrfToken } from '@composables/useCsrfToken.js'
import { clampText } from '@shared/util.js'

export default {
  components: {
    FeaturedBadges,
    InquiryForm,
    RecentlyViewedProperties,
    ShareBookmark,
  },

  setup() {
    const agent = ref(null)
    const badges = ref(app.page.feature_badges)
    const mode = ref('property')
    const openingDescription = ref(false)
    const recaptchaToken = ref(null)

    const { hidePropertySearchBox, showPropertySearchBox } = usePropertySearchBox()
    const { callGet, callPost } = useAjax()
    const {
      intlCountry,
      intlNumber,
      initializeIntlTel
    } = useIntlTel("#intl_phone2")

    const meta = document.querySelector("meta[name=viewport]")
    const viewport = meta.getAttribute('content')

    /**
     * 不動産会社の取得
     */
    const getAgent = async () => {
      const response = await callGet(window.app.page.agent_path)
      agent.value = response.agent
    }

    /**
     * 物件表示に戻る
     */
    const handleClickBackProperty = () => {
      mode.value = 'property'
      showPropertySearchBox()
      meta.setAttribute('content', viewport)
      nextTick(() => $('body, html').scrollTop(0))
    }

    /**
     * PR文をクリック
     */
    const handleClickDescription = () => openingDescription.value = !openingDescription.value

    /**
     * 画像をクリック
     */
    const handleClickImage = async () => {
      mode.value = 'images'
      hidePropertySearchBox()
      meta.setAttribute('content', "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=2.0,user-scalable=yes")

      // 若干強引だけど、問い合わせフォーム用・・・
      const { country, phone } = window.app.page
      const { getCsrfToken } = useCsrfToken()
      initializeIntlTel({ country, phone })
      recaptchaToken.value = $("#recaptcha_token").val()
      const token = await getCsrfToken()
      $(".contact_agent input[name=authenticity_token]").val(token)
    }

    getAgent()

    callPost(window.app.page.tracking_path)

    return {
      agent,
      badges,
      mode,
      openingDescription,
      handleClickBackProperty,
      handleClickDescription,
      handleClickImage,
      intlCountry,
      intlNumber,
      recaptchaToken,
    }
  },

  mounted() {
    initializePhoto()
    initializeTooltips()
    initializeAccordion()
    setTimeout(() => document.querySelectorAll('.loading').forEach((element) => element.classList.remove('loading')), 500)
  },

  methods: {
    clampText
  },
}

// デザインのコードをそのまま持ってきた
const initializePhoto = () => {
  $(".photo_main_list")
    .on("init", function (event, slick) {
      $(this).append('<div class="slick-num"><span class="now-count"></span> / <span class="all-count"></span></div>');
      $(".now-count").text(slick.currentSlide + 1);
      $(".all-count").text(slick.slideCount);
    })

  let slide_main = $(".photo_main_list").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: ".photo_nav_list",
    cssEase: 'ease-out',
    responsive: [
      {
        breakpoint: 993,
        settings: {
          arrows: false,
          fade: false,
          speed: 240,
        }
      }
    ]
  })
  .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    $(".now-count").text(nextSlide + 1);
  })

  let slide_sub = $(".photo_nav_list").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 300,
    asNavFor: ".photo_main_list",
    arrows: true,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 4,
          adaptiveHeight: true
        }
      }
    ]
  })

  let open_window_Width = $(window).width()
  $(window).resize(function() {
    var width = $(window).width()
    if (open_window_Width != width) {
      slide_main.slick("setPosition")
      slide_sub.slick("setPosition")
    }
  })
}

// デザインのコードをそのまま持ってきた
const initializeTooltips = () => {
  $('.c-info_btn').on('click', function (e) {
    e.stopPropagation()

    const $btn = $(this)
    const $wrap = $btn.parent()
    const $block = $wrap.find('.c-info_block')
    $('.c-info_block').not($block).removeClass('is-open')

    const pos = $btn.position().left + ($btn.outerWidth() / 2)
    $block.css('--before-left', pos + 'px')
    $block.toggleClass('is-open')
  })

  $('.c-info_block').on('click', function (e) {
    e.stopPropagation()
  })

  $(document).on('click', function () {
    $('.c-info_block').removeClass('is-open')
  })
}

// デザインのコードをそのまま持ってきた
const initializeAccordion = () => {
  $('.js-acc__item').on('click', function() {
    var $acc = $(this).closest('.js-acc')
    var $content = $acc.find('.js-acc__content')
    $acc.toggleClass('is-open')
    $content.stop().slideToggle(300)
  })
}
